import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import InputField from "../../../components/InputField";
import Button from "../../../components/Button";
import BackButton from "../../../components/BackButton";
import api from "../../../api/api";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Select from "react-select";
import "../../form.css";
import SelectField from "../../../components/SelectField";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

const PurchaseForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const enqIdFromQuery = searchParams.get("enq_id");

  useEffect(() => {
    if (id === "new" && !enqIdFromQuery) {
      alert(
        "Missing enquiry ID. Cannot create a new purchase entry without an enquiry. Please select a valid enquiry.",
      );
      navigate("/billingAndInvoice/invoicing");
    }
  }, [id, enqIdFromQuery, navigate]);

  const [isEditing, setIsEditing] = useState(false);
  const [loadingPurchase, setLoadingPurchase] = useState(false);
  const [existingPurchaseId, setExistingPurchaseId] = useState(null);
  const [showExchangeRateModal, setShowExchangeRateModal] = useState(false);
const [selectedExchangeRate, setSelectedExchangeRate] = useState({
  vendorId: null,
  currency: "",
  rate: "",
});

const handleOpenExchangeRateModal = (vendorId, currency, rate) => {
  setSelectedExchangeRate({
    vendorId,
    currency,
    rate: rate ?? "",
  });

  setShowExchangeRateModal(true);
};

const handleSaveExchangeRate = () => {
  const { vendorId, currency, rate } = selectedExchangeRate;

  if (rate === "" || !Number.isFinite(Number(rate)) || Number(rate) <= 0) {
    alert("Please enter a valid exchange rate.");
    return;
  }

  updateCurrencyExchangeRate(vendorId, currency, Number(rate));

  setShowExchangeRateModal(false);
};

  const [formData, setFormData] = useState({
    job_number: "",
    po_number: "",
    actual_shipper: "",
    actual_consignee: "",
    house_bl_number: "",
    container_type: "",
    gross_wt: "",
    packaging: "",
    purchase_invoice_number: "",
    voucher_invoice_number: "",
    voucher_invoice_date: "",
    purchase_invoice_date: "",
    vendor_name: "",
    vendor_location: "",
    shipper: "GFR Logistic India",
    consignee: "",
    vessel_name: "",
    vessel_number: "",
    voyage_number: "",
    mbl_number: "",
    vb_number: "",
    vendor_job_number: "",
    container_number: "",
    etd_date: "",
    gst_number: "",
    pan_number: "",
    inv_number: "",
    invoice_date: "",
    vendor_performa_invoice_number: "",
    billing_party: "",
    pol: "",
    pod: "",
    number_of_packages: "",
    notify_party: "",
    cut_off_date: "",
    shipment_segment: "",
    incoterms: "",
    freight_terms: "",
    container_count: 0,
  });

  const [voucherDate, setVoucherDate] = useState(null);
  const [vendorInvoiceDates, setVendorInvoiceDates] = useState([]);

  const [portsOptions, setPortsOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingPorts, setLoadingPorts] = useState(true);

  const [chargeCodeOptions, setChargeCodeOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [loadingCurrencies, setLoadingCurrencies] = useState(false);
  const [loadingChargeCodes, setLoadingChargeCodes] = useState(false);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [errors, setErrors] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [fileModalVendorId, setFileModalVendorId] = useState(null);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [submitPayload, setSubmitPayload] = useState(null);

  const [inputRow, setInputRow] = useState({});

  const [containerTableData, setContainerTableData] = useState([]);

  const handleContainerChange = (index, field, value) => {
    setContainerTableData((prev) => {
      const updated = [...prev];
      console.log("updatedupdated", updated)
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const deleteChargeRow = (vendorIndex, index) => {
    setVendors((prev) => {
      const updated = [...prev];
      updated[vendorIndex].chargeRows = updated[vendorIndex].chargeRows.filter(
        (_, i) => i !== index,
      );
      return updated;
    });
  };

  const chargeRowDefault = {
    charge_code: "",
    sac_code: "",
    currency: "",
    exchange_rate: "",
    amount_in_inr: "",
    rate: "",
    quantity: "",
    taxable_amount: "",
    gst: "",
    gst_amount: "",
    cgst: "",
    sgst: "",
    igst: "",
    gst_applicable: "No",
    applicableContainers: [], // array of container_id(s) this charge is entered against
  };

  // --- GST state-code helpers ---
  // Job number format: FE3309260002  ->  [0:2]=segment, [2:4]=office state code
  const getOfficeStateCode = () => {
    const jn = formData.job_number || "";
    return jn.length >= 4 ? jn.slice(2, 4).toUpperCase() : "";
  };

  const getVendorStateCode = (vendor) => {
    const gstin = (vendor && vendor.gst_number) || "";
    return gstin.length >= 2 ? gstin.slice(0, 2).toUpperCase() : "";
  };

  // Returns "CGST_SGST" when vendor & office are in same state, else "IGST"
  const getGstType = (vendor) => {
    const office = getOfficeStateCode();
    const vendorState = getVendorStateCode(vendor);
    if (office && vendorState && office === vendorState) return "CGST_SGST";
    return "IGST";
  };

  // Build container options (id + label) from the job's container details
  const containerOptions = containerTableData.map((c, i) => ({
    value: c.container_id !== undefined && c.container_id !== null ? c.container_id : i,
    label: c.container_number
      ? `${c.container_number}${c.container_type ? " (" + c.container_type + ")" : ""}`
      : `Container ${i + 1}${c.container_type ? " (" + c.container_type + ")" : ""}`,
  }));

  const getEmptyVendorBlock = () => ({
    vendor_id: null,
    vendor_name: "",
    vendor_location: "",
    gst_number: "",
    pan_number: "",
    voucher_invoice_number: "",
    voucher_invoice_date: "",
    vb_number: "",
    vendor_job_number: "",
    shipper: "GFR Logistic India",
    consignee: "",
    mbl_number: "",
    vessel_name: "",
    vessel_number: "",
    voyage_number: "",
    tds_deduct: false,
    tds_percentage: "0",
    tds_amount: "",
    total_taxable_amount: "",
    total_gst_amount: "",
    grand_total_amount: "",
    etd_date: "",
    cut_off_date: "",
    purchase_invoice_file: [],
    inputChargeRow: { ...chargeRowDefault },
    chargeRows: [],
  });

  const [vendors, setVendors] = useState([]);

  const vendorFileRefs = useRef({});

  const removeVendor = (vendorId) => {
    setVendors((prev) => prev.filter((v) => v.id !== vendorId));
  };

  const addVendor = () => {
    setVendors((prev) => [
      ...prev,
      { ...getEmptyVendorBlock(), id: Date.now() },
    ]);
  };

  const updateVendor = (vendorId, field, value) => {
    setVendors((prev) =>
      prev.map((v) => (v.id === vendorId ? { ...v, [field]: value } : v)),
    );
  };

  const addVendorFiles = (vendorId, files) => {
    const incoming = Array.from(files || []);
    if (incoming.length === 0) return;
    setVendors((prev) =>
      prev.map((v) =>
        v.id === vendorId
          ? {
            ...v,
            purchase_invoice_file: [
              ...(v.purchase_invoice_file || []),
              ...incoming,
            ],
          }
          : v,
      ),
    );
  };

  const removeVendorFile = (vendorId, fileIndex) => {
    setVendors((prev) =>
      prev.map((v) =>
        v.id === vendorId
          ? {
            ...v,
            purchase_invoice_file: (v.purchase_invoice_file || []).filter(
              (_, i) => i !== fileIndex,
            ),
          }
          : v,
      ),
    );
  };

  // Resolve a stored file (File object or string URL) to a display name + openable URL
  const getFileName = (file) =>
    typeof file === "string" ? file.split("/").pop() : file.name;

  const openFileInNewTab = (file) => {
    const url = typeof file === "string" ? file : URL.createObjectURL(file);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const updateVendorInputCharge = (vendorId, field, value) => {
    setVendors((prev) =>
      prev.map((v) => {
        if (v.id !== vendorId) return v;
        const updatedInput = { ...v.inputChargeRow, [field]: value };
        if (field === "gst_applicable" && value === "No") {
          updatedInput.gst = "0";
          updatedInput.gst_amount = "0";
          updatedInput.cgst = "0";
          updatedInput.sgst = "0";
          updatedInput.igst = "0";
        }
        if (
          field === "rate" ||
          field === "quantity" ||
          field === "exchange_rate" ||
          field === "currency"
        ) {
          const rate = Number(updatedInput.rate || 0);
          const quantity = Number(updatedInput.quantity || 0);
          const exchange = Number(updatedInput.exchange_rate) || 1;
          const taxable = rate * quantity * exchange;
          updatedInput.taxable_amount = Number(taxable.toFixed(2)).toString();
          updatedInput.amount_in_inr = Number(taxable.toFixed(2));
        }
        return { ...v, inputChargeRow: updatedInput };
      }),
    );
  };

  const handleCurrencyChange = async (vendorId, index, selectedCurrency) => {
    const country_code = selectedCurrency?.value || "";
    if (index === "input") {
      updateVendorInputCharge(vendorId, "currency", country_code);
    } else {
      handleVendorChargeInputChange(vendorId, index, "currency", country_code);
    }

    if (!country_code) {
      if (index === "input") {
        updateVendorInputCharge(vendorId, "exchange_rate", "");
      } else {
        handleVendorChargeInputChange(vendorId, index, "exchange_rate", "");
      }
      return;
    }

    try {
      const res = await api.get(`/exchange_rate/rate/${country_code}`);
      if (index === "input") {
        updateVendorInputCharge(
          vendorId,
          "exchange_rate",
          Number(res.data.rate_in_INR),
        );
      } else {
        handleVendorChargeInputChange(
          vendorId,
          index,
          "exchange_rate",
          Number(res.data.rate_in_INR),
        );
      }
    } catch (err) {
      console.error("Failed to fetch exchange rate:", err);
      if (index === "input") {
        updateVendorInputCharge(vendorId, "exchange_rate", "N/A");
      } else {
        handleVendorChargeInputChange(vendorId, index, "exchange_rate", "N/A");
      }
    }
  };

  const handleVendorChargeInputChange = (vendorId, index, field, value) => {
    setVendors((prev) =>
      prev.map((v) => {
        if (v.id !== vendorId) return v;
        const updated = [...v.chargeRows];
        updated[index] = { ...updated[index], [field]: value };
        if (field === "gst_applicable" && value === "No") {
          updated[index].gst = "0";
          updated[index].gst_amount = "0";
          updated[index].cgst = "0";
          updated[index].sgst = "0";
          updated[index].igst = "0";
        }
        if (
          field === "rate" ||
          field === "quantity" ||
          field === "exchange_rate" ||
          field === "currency"
        ) {
          const rate = Number(updated[index].rate || 0);
          const quantity = Number(updated[index].quantity || 0);
          const exchange = Number(updated[index].exchange_rate) || 1;
          const taxable = rate * quantity * exchange;
          updated[index].taxable_amount = Number(taxable.toFixed(2)).toString();
          updated[index].amount_in_inr = Number(taxable.toFixed(2));
        }
        return { ...v, chargeRows: updated };
      }),
    );
  };

  const updateCurrencyExchangeRate = (vendorId, currency, newRate) => {
    setVendors((prev) =>
      prev.map((v) => {
        if (v.id !== vendorId) return v;

        const gstType = getGstType(v);
        const exchange = Number(newRate) || 0;

        const recompute = (row) => {
          if (row.currency !== currency) return row;
          const rate = Number(row.rate || 0);
          const quantity = Number(row.quantity || 0);
          const taxable = rate * quantity * (exchange || 1);
          const withAmounts = {
            ...row,
            exchange_rate: newRate,
            taxable_amount: Number(taxable.toFixed(2)).toString(),
            amount_in_inr: Number(taxable.toFixed(2)),
          };
          const gstPct =
            withAmounts.gst_applicable === "Yes"
              ? Number(withAmounts.gst) || 0
              : 0;
          return calculateGST(withAmounts, gstPct, gstType);
        };

        return {
          ...v,
          inputChargeRow: recompute(v.inputChargeRow),
          chargeRows: v.chargeRows.map(recompute),
        };
      }),
    );
  };

  const calculateGST = (row, gstPercentage = 0, gstType = "CGST_SGST") => {
    const taxableAmount = parseFloat(row.taxable_amount) || 0;

    // Taxable Amount already final amount hai
    const taxAmount = taxableAmount;

    const gst =
      row.gst_applicable === "Yes" ? parseFloat(gstPercentage) || 0 : 0;

    const gstAmount = (taxAmount * gst) / 100;

    let cgst = 0,
      sgst = 0,
      igst = 0;
    if (gstType === "IGST") {
      igst = gstAmount;
    } else {
      cgst = gstAmount / 2;
      sgst = gstAmount / 2;
    }

    const total = taxAmount + gstAmount;

    return {
      ...row,
      gst: Number(gst.toFixed(2)),
      tax: Number(taxAmount.toFixed(2)),
      gst_amount: Number(gstAmount.toFixed(2)),
      cgst: Number(cgst.toFixed(2)),
      sgst: Number(sgst.toFixed(2)),
      igst: Number(igst.toFixed(2)),
      total: Number(total.toFixed(2)),
    };
  };

  const fetchGSTForChargeCode = async (charge_code, vendorId, index) => {
    if (!charge_code) return;

    try {
      const response = await api.get(`/charge_code/gst/${charge_code}`);

      const gstPercentage = Number(response.data.tax_percentage) || 0;

      setVendors((prev) =>
        prev.map((v) => {
          if (v.id !== vendorId) return v;

          const gstType = getGstType(v);

          // Input row
          if (index === "input") {
            const row = {
              ...v.inputChargeRow,
            };

            // GST Applicable YES hai tabhi charge code ka GST %
            // apply hoga
            const gst = row.gst_applicable === "Yes" ? gstPercentage : 0;

            const updatedRow = calculateGST(
              {
                ...row,
                gst,
              },
              gst,
              gstType,
            );

            return {
              ...v,
              inputChargeRow: updatedRow,
            };
          }

          // Existing charge row
          const updatedRows = [...v.chargeRows];
          const row = {
            ...updatedRows[index],
          };

          const gst = row.gst_applicable === "Yes" ? gstPercentage : 0;

          updatedRows[index] = calculateGST(
            {
              ...row,
              gst,
            },
            gst,
            gstType,
          );

          return {
            ...v,
            chargeRows: updatedRows,
          };
        }),
      );
    } catch (err) {
      console.error("Failed to fetch GST for charge code:", err);
    }
  };

  const addChargeRow = (vendorId) => {
    setVendors((prev) =>
      prev.map((v) => {
        if (v.id !== vendorId) return v;
        const { inputChargeRow } = v;
        if (!inputChargeRow.charge_code || !inputChargeRow.currency) {
          setErrors((prevErr) => ({
            ...prevErr,
            chargeTable: `Vendor ${prev.findIndex((x) => x.id === vendorId) + 1
              }: Please fill Charge Code and Currency before adding a new row`,
          }));
          return v;
        }

        setErrors((prevErr) => ({ ...prevErr, chargeTable: "" }));

        return {
          ...v,
          chargeRows: [...v.chargeRows, { ...inputChargeRow }],
          inputChargeRow: { ...chargeRowDefault },
        };
      }),
    );
  };

  useEffect(() => {
    const loadData = async () => {
      await fetchPorts();
      if (!id) return;

      if (id === "new") {
        setIsEditing(false);
        if (enqIdFromQuery) {
          await fetchEnquiryData(enqIdFromQuery);
        }
        return;
      }

      if (!isNaN(Number(id))) {
        setIsEditing(true);
        await loadExistingPurchase(Number(id));
      } else {
        setIsEditing(false);
        await fetchEnquiryData(id);
      }
    };
    loadData();
  }, [id, enqIdFromQuery]);

  const fetchPorts = async () => {
    try {
      setLoadingPorts(true);
      const res = await api.get("/ports");
      const options = res.data.map((p) => ({
        value: p.Port_id,
        label: p.Port_names,
      }));
      setPortsOptions(options);
    } catch (err) {
      console.error("Error fetching ports:", err);
    } finally {
      setLoadingPorts(false);
    }
  };

  const loadExistingPurchase = async (purchaseInvoiceId) => {
    try {
      setLoadingPurchase(true);
      const res = await api.get(`/purchase/${purchaseInvoiceId}`);
      const data = res.data;
      if (!data || !data.success) {
        alert("Purchase entry not found");
        navigate("/billingAndInvoice/invoicing");
        return;
      }

      setExistingPurchaseId(data.purchase_invoice_id);

      setFormData((prev) => ({
        ...prev,
        enq_id: data.enq_id || "",
        job_number: data.job_number || "",
        po_number: data.po_number || "",
        purchase_invoice_number: data.purchase_invoice_number || "",
        purchase_invoice_date: data.purchase_invoice_date || "",
        actual_shipper: data.actual_shipper || "",
        actual_consignee: data.actual_consignee || "",
        house_bl_number: data.house_bl_number || "",
        pol: data.pol || "",
        pod: data.pod || "",
        notify_party: data.notify_party || "",
        gross_wt: data.gross_wt || "",
        number_of_packages: data.number_of_packages || "",
        shipment_segment: data.shipment_segment || "",
        incoterms: data.incoterms || "",
        freight_terms: data.freight_terms || "",
        container_count: data.container_count || 0,
      }));

      const loadedVendors = (data.vendorEntries || []).map((v) => ({
        id: v.vendor_entry_id || Date.now(),
        vendor_id: v.vendor_id,
        vendor_name: v.vendor_name || "",
        vendor_location: v.vendor_location || "",
        vendor_total: v.vendor_total ?? 0,
        gst_number: v.party_gstin || "",
        pan_number: v.pan_number || "",
        mbl_number: v.mbl_number || "",
        vessel_name: v.vessel_name || "",
        vessel_number: v.vessel_number || "",
        voyage_number: v.voyage_number || "",
        tds_deduct: Boolean(v.tds_deduct),
        tds_percentage: v.tds_percentage || "0",
        tds_amount: v.tds_amount || "",
        total_taxable_amount: v.total_taxable_amount || "",
        total_gst_amount: v.total_gst_amount || "",
        grand_total_amount: v.grand_total_amount || "",
        voucher_invoice_number: v.voucher_invoice_number || "",
        voucher_invoice_date: v.voucher_invoice_date || "",
        vb_number: v.vb_number || "",
        vendor_job_number: v.vendor_job_number || "",
        shipper: v.shipper || "",
        consignee: v.consignee || "",
        etd_date: v.etd_date || "",
        cut_off_date: v.cut_off_date || "",
        purchase_invoice_file: Array.isArray(v.purchase_invoice_file)
          ? v.purchase_invoice_file
          : v.purchase_invoice_file
            ? [v.purchase_invoice_file]
            : [],
        inputChargeRow: { ...chargeRowDefault },
        chargeRows: (v.charges || []).map((c) => ({
          charge_code: c.charge_code || "",
          sac_code: c.sac_code || "",
          currency: c.currency || "",
          exchange_rate: c.exchange_rate || "",
          rate: c.rate || "",
          quantity: c.quantity || "",
          taxable_amount: c.taxable_amount || "",
          amount_in_inr: c.amount_in_inr || "",
          gst: c.gst_percentage || "",
          gst_amount: c.gst_amount || "",
          cgst: c.cgst || "",
          sgst: c.sgst || "",
          igst: c.igst || "",
          gst_applicable: c.gst_applicable || "Yes",
          applicableContainers: c.applicableContainers || [],
        })),
      }));

      setVendors(loadedVendors);

      // Containers are stored against the enquiry, not the purchase header,
      // so load them via the enquiry endpoint to populate the container table.
      if (data.enq_id) {
        try {
          const enqRes = await api.get(`/enquiry/viewEnquiry/${data.enq_id}`);
          setContainerTableData(
            enqRes.data.containerDetails?.map((c, i) => ({
              container_id: c.container_id ?? i,
              container_type: c.container_type,
              container_number: c.container_number || "",
              seal_number: c.seal_number || "",
              container_weight: c.container_weight,
              container_length: c.container_length,
              container_breadth: c.container_breadth,
              container_height: c.container_height,
              container_temperature: c.container_temperature,
            })) || [],
          );
        } catch (containerErr) {
          console.error("Failed to load containers for purchase:", containerErr);
        }
      }
    } catch (err) {
      console.error("Failed to load purchase entry:", err);
      alert("Failed to load purchase entry.");
      navigate("/billingAndInvoice/invoicing");
    } finally {
      setLoadingPurchase(false);
    }
  };

  const fetchEnquiryData = async (enqId) => {
    try {
      setLoadingData(true);
      const res = await api.get(`/enquiry/viewEnquiry/${enqId}`);
      const data = res.data;
      const enquiry = data;
      console.log("enquiryenquiry", res)
      if (enquiry) {
        setFormData((prev) => ({
          ...prev,
          job_number: enquiry.job_number || "",
          actual_shipper: enquiry.first_shipper_name || "",
          actual_consignee: enquiry.first_consignee_name || "",
          pol: enquiry.pol || "",
          pod: enquiry.pod || "",
          house_bl_number: enquiry.house_bl_number || "",
          container_type: enquiry.container_type || "",
          gross_wt: enquiry.gross_weight || "",
          packaging: enquiry.package_count || "",
          shipper: "",
          consignee: "",
          vessel_name: enquiry.vessel_name || "",
          voyage_number: enquiry.voyage_number || "",
          number_of_packages: enquiry.package_count || "",
          shipment_segment: enquiry.shipment_segment || "",
          incoterms: enquiry.incoterm || "",
          freight_terms: enquiry.freight_terms || "",
          container_count: res.data.containerDetails?.length || 0,
        }));
        setContainerTableData(
          res.data.containerDetails?.map((c, i) => ({               // line 692 → maps the 1 container
            container_id: c.container_id ?? i,
            container_type: c.container_type,
            container_number: c.container_number || "",
            seal_number: c.seal_number || "",
            container_weight: c.container_weight,
            container_length: c.container_length,
            container_breadth: c.container_breadth,
            container_height: c.container_height,
            container_temperature: c.container_temperature,
          })) || [],
        );
      }

      /* Existing purchase pre-population removed - start fresh for new purchases */
    } catch (error) {
      console.error("❌ Error fetching enquiry data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    const fetchExchangeRates = async () => {
      try {
        setLoadingCurrencies(true);
        const response = await api.get("/exchange_rate");

        const formatted = response.data.map((item) => ({
          value: item.country_code,
          label: item.country_code,
        }));

        setCurrencyOptions(formatted);
      } catch (err) {
        console.error("Failed to fetch exchange rates:", err);
      } finally {
        setLoadingCurrencies(false);
      }
    };

    fetchExchangeRates();
  }, []);

  useEffect(() => {
    const fetchChargeCodes = async () => {
      try {
        setLoadingChargeCodes(true);
        const response = await api.get("/charge_code/options");

        setChargeCodeOptions(response.data);
      } catch (err) {
        console.error("Failed to fetch charge codes:", err);
      } finally {
        setLoadingChargeCodes(false);
      }
    };

    fetchChargeCodes();
  }, []);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        setLoadingVendors(true);
        const response = await api.get("/master-data/vendor-master");
        const vendors = (response.data.vendors || []).map((v) => ({
          value: v.vendor_id,
          label: v.name,
          ...v,
        }));
        setVendorOptions(vendors);
      } catch (err) {
        console.error("Failed to fetch vendors:", err);
      } finally {
        setLoadingVendors(false);
      }
    };

    fetchVendors();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePolChange = (opt) => {
    setFormData((prev) => ({
      ...prev,
      pol: opt?.value || "",
    }));
  };

  const handlePodChange = (opt) => {
    setFormData((prev) => ({
      ...prev,
      pod: opt?.value || "",
    }));
  };

  const handleFormChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleVendorSelect = (selectedVendor, vendorId) => {
    if (!selectedVendor) {
      updateVendor(vendorId, "vendor_id", null);
      updateVendor(vendorId, "vendor_name", "");
      updateVendor(vendorId, "vendor_location", "");
      updateVendor(vendorId, "gst_number", "");
      updateVendor(vendorId, "pan_number", "");
      updateVendor(vendorId, "tds_percentage", "0");
      return;
    }

    updateVendor(vendorId, "vendor_id", selectedVendor.vendor_id);
    updateVendor(vendorId, "vendor_name", selectedVendor.name || "");
    updateVendor(vendorId, "vendor_location", selectedVendor.location || "");
    updateVendor(vendorId, "gst_number", selectedVendor.gst_number || "");
    updateVendor(vendorId, "pan_number", selectedVendor.pan_number || "");
    updateVendor(vendorId, "tds_percentage", selectedVendor.tds_percentage || "0");

    // Vendor GSTIN changed -> re-evaluate CGST/SGST vs IGST for all charge rows
    setVendors((prev) =>
      prev.map((v) => {
        if (v.id !== vendorId) return v;
        const gstType = getGstType(v);
        const updatedRows = v.chargeRows.map((c) => {
          if (c.gst_applicable !== "Yes" || !c.charge_code) return c;
          const gstPct = Number(c.gst) || 0;
          return calculateGST(
            { ...c, gst: gstPct },
            gstPct,
            gstType,
          );
        });
        return { ...v, chargeRows: updatedRows };
      }),
    );
  };

  const validate = () => {
    const err = {};

    if (!formData.purchase_invoice_number)
      err.purchase_invoice_number = "Purchase Invoice Number is required";
    if (!formData.purchase_invoice_date)
      err.purchase_invoice_date = "Purchase Invoice Date is required";
    if (!formData.actual_shipper)
      err.actual_shipper = "Actual Shipper is required";
    if (!formData.actual_consignee)
      err.actual_consignee = "Actual Consignee is required";
    if (!formData.pol) err.pol = "Port of Loading is required";
    if (!formData.pod) err.pod = "Port of Discharge is required";
    if (!formData.notify_party) err.notify_party = "Notify Party is required";
    if (!formData.gross_wt) err.gross_wt = "Gross Weight is required";
    if (!formData.number_of_packages)
      err.number_of_packages = "Number of Packages is required";
    if (!formData.shipment_segment)
      err.shipment_segment = "Shipment Segment is required";
    if (!formData.incoterms) err.incoterms = "Incoterms is required";
    if (!formData.po_number) err.po_number = "Purchase Order Number is Required";
    if (!formData.freight_terms) err.freight_terms = "Freight Terms is required";

    const hasContainerNumber = containerTableData.some(
      (c) => c.container_number && c.container_number.trim(),
    );
    if (!hasContainerNumber)
      err.containerTable = "At least one container number is required";

    if (vendors.length === 0) {
      err.vendorTable = "At least one vendor is required";
    } else {
      vendors.forEach((v, idx) => {
        if (!v.vendor_id)
          err[`vendor_${idx}_id`] = `Vendor ${idx + 1}: Please select a vendor`;
        if (!v.voucher_invoice_number)
          err[`vendor_${idx}_voucher_invoice_number`] =
            `Vendor ${idx + 1}: Vendor Invoice Number is required`;
        if (!v.voucher_invoice_date)
          err[`vendor_${idx}_voucher_invoice_date`] =
            `Vendor ${idx + 1}: Vendor Invoice Date is required`;

        if (v.chargeRows.length === 0) {
          err[`vendor_${idx}_charges`] =
            `Vendor ${idx + 1}: At least one charge is required`;
        } else {
          v.chargeRows.forEach((c, cIdx) => {
            if (!c.charge_code)
              err[`vendor_${idx}_charge_${cIdx}_code`] =
                `Vendor ${idx + 1} Charge ${cIdx + 1}: Charge Code is required`;
            if (!c.currency)
              err[`vendor_${idx}_charge_${cIdx}_currency`] =
                `Vendor ${idx + 1} Charge ${cIdx + 1}: Currency is required`;
            if (!c.rate && c.rate !== 0)
              err[`vendor_${idx}_charge_${cIdx}_rate`] =
                `Vendor ${idx + 1} Charge ${cIdx + 1}: Rate is required`;
            if (!c.quantity && c.quantity !== 0)
              err[`vendor_${idx}_charge_${cIdx}_quantity`] =
                `Vendor ${idx + 1} Charge ${cIdx + 1}: Quantity is required`;
          });
        }
      });
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("okok")
    if (!validate()) return;
    console.log("okok1")

    const vendorEntries = vendors.map((v) => ({
      vendor_id: v.vendor_id,
      vendor_name: v.vendor_name,
      vendor_location: v.vendor_location,
      gst_number: v.gst_number,
      pan_number: v.pan_number,
      mbl_number: v.mbl_number,
      vessel_name: v.vessel_name,
      vessel_number: v.vessel_number,
      voyage_number: v.voyage_number,
      voucher_invoice_number: v.voucher_invoice_number,
      voucher_invoice_date: v.voucher_invoice_date,
      vb_number: v.vb_number,
      vendor_job_number: v.vendor_job_number,
      shipper: v.shipper,
      consignee: v.consignee,
      etd_date: v.etd_date,
      cut_off_date: v.cut_off_date,
      purchase_invoice_file: v.purchase_invoice_file,
      vendor_total: Number(
        v.chargeRows
          .reduce((sum, c) => sum + (Number(c.amount_in_inr) || 0), 0)
          .toFixed(2),
      ),
      tds_deduct: v.tds_deduct === true,
      tds_percentage: v.tds_percentage,
      tds_amount: Number(
        (v.tds_deduct === true
          ? (v.chargeRows.reduce((sum, c) => sum + (Number(c.taxable_amount) || 0), 0) *
            (Number(v.tds_percentage) || 0)) /
          100
          : 0
        ).toFixed(2),
      ),
      total_taxable_amount: Number(
        v.chargeRows
          .reduce((sum, c) => sum + (Number(c.taxable_amount) || 0), 0)
          .toFixed(2),
      ),
      total_gst_amount: Number(
        v.chargeRows
          .reduce((sum, c) => sum + (Number(c.gst_amount) || 0), 0)
          .toFixed(2),
      ),
      grand_total_amount: Number(
        (v.chargeRows.reduce((sum, c) => sum + (Number(c.taxable_amount) || 0), 0) +
          v.chargeRows.reduce((sum, c) => sum + (Number(c.gst_amount) || 0), 0) -
          (v.tds_deduct === true
            ? (v.chargeRows.reduce((sum, c) => sum + (Number(c.taxable_amount) || 0), 0) *
              (Number(v.tds_percentage) || 0)) /
            100
            : 0)).toFixed(2),
      ),
      charges: v.chargeRows.map((c) => ({
        charge_code: c.charge_code,
        sac_code: c.sac_code,
        currency: c.currency,
        exchange_rate: c.exchange_rate,
        rate: c.rate,
        quantity: c.quantity,
        taxable_amount: c.taxable_amount,
        amount_in_inr: c.amount_in_inr,
        gst_applicable: c.gst_applicable || "Yes",
        gst_percentage: c.gst,
        gst_amount: c.gst_amount,
        cgst: c.cgst,
        sgst: c.sgst,
        igst: c.igst,
        container_ids: c.applicableContainers || [],
      })),
    }));

    const payload = {
      enq_id: id === "new" ? enqIdFromQuery : formData.enq_id,
      job_number: formData.job_number,
      po_number: formData.po_number,
      purchase_invoice_number: formData.purchase_invoice_number,
      purchase_invoice_date: formData.purchase_invoice_date,
      actual_shipper: formData.actual_shipper,
      actual_consignee: formData.actual_consignee,
      house_bl_number: formData.house_bl_number,
      pol: formData.pol,
      pod: formData.pod,
      notify_party: formData.notify_party,
      gross_wt: formData.gross_wt,
      number_of_packages: formData.number_of_packages,
      shipment_segment: formData.shipment_segment,
      incoterms: formData.incoterms,
      freight_terms: formData.freight_terms,
      container_count: formData.container_count,
      vendorEntries,
    };

    setSubmitPayload(payload);
    setShowConfirm(true);
  };

  const confirmSubmit = async () => {
    setShowConfirm(false);
    setLoadingSubmit(true);
    try {
      const url = isEditing
        ? `/purchase/${existingPurchaseId}`
        : "/purchase/create";
      const method = isEditing ? "put" : "post";

      const res = await api({ method, url, data: submitPayload });
      if (res.data.success) {
        setShowSuccess(true);
      } else {
        alert(res.data.error || "Failed to save purchase details.");
      }
    } catch (error) {
      console.error("❌ Error saving purchase form:", error);
      alert("Failed to save purchase details. Please try again.");
    } finally {
      setLoadingSubmit(false);
    }
  };

  const DatePickerField = ({ selected, onChange, placeholder, error }) => (
    <div style={{ position: "relative", width: "100%" }}>
      <DatePicker
        selected={selected}
        onChange={onChange}
        dateFormat="dd/MM/yyyy"
        wrapperClassName="w-100"
        className={`form-control w-100 ${error ? "is-invalid" : ""}`}
        placeholderText="DD/MM/YYYY"
        calendarClassName="custom-calendar"
      />
      <CalendarMonthIcon
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          color: "#6c757d",
        }}
      />
    </div>
  );

  if (loadingData || loadingPorts || loadingPurchase) {
    return (
      <>
        <BackButton />
        <div className="text-center py-5">Loading...</div>
      </>
    );
  }

  return (
    <>
      <BackButton />

      <form onSubmit={handleSubmit}>
        <h5 className="mb-3 border-bottom pb-2">As Per Our Data</h5>
        <div className="row g-3 mb-4">
          <div className="col-md-4">
            <InputField
              label="Job Number"
              name="job_number"
              value={formData.job_number}
              onChange={handleChange}
              disabled
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Purchase Order Number"
              name="po_number"
              value={formData.po_number}
              onChange={handleChange}
              error={errors.po_number}
              placeholder="Enter Purchase Order Number"
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Purchase Invoice Number"
              name="purchase_invoice_number"
              value={formData.purchase_invoice_number}
              onChange={handleChange}
              placeholder="Enter Purchase Invoice Number"
              error={errors.purchase_invoice_number}

            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Purchase Invoice Date</label>
            <DatePickerField
              selected={voucherDate}
              onChange={(date) => {
                setVoucherDate(date);
                handleFormChange("purchase_invoice_date", date);
              }}
              placeholder="DD/MM/YYYY"
              error={errors.purchase_invoice_date}
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Actual Shipper Name"
              name="actual_shipper"
              value={formData.actual_shipper}
              onChange={handleChange}
              placeholder="Enter Actual Shipper"
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Actual Consignee Name"
              name="actual_consignee"
              value={formData.actual_consignee}
              onChange={handleChange}
              placeholder="Enter Actual Consignee"
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="House BL Number"
              name="house_bl_number"
              value={formData.house_bl_number}
              onChange={handleChange}
              placeholder="Enter House BL Number"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Port of Loading</label>
            <Select
              options={portsOptions}
              value={
                portsOptions.find((p) => p.value === formData.pol) ||
                (formData.pol
                  ? { value: formData.pol, label: formData.pol }
                  : null)
              }
              onChange={handlePolChange}
              placeholder="Select Port of Loading"
              isClearable
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Port of Discharge</label>
            <Select
              options={portsOptions}
              value={
                portsOptions.find((p) => p.value === formData.pod) ||
                (formData.pod
                  ? { value: formData.pod, label: formData.pod }
                  : null)
              }
              onChange={handlePodChange}
              placeholder="Select Port of Discharge"
              isClearable
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Notify Party"
              name="notify_party"
              value={formData.notify_party || ""}
              onChange={handleChange}
              placeholder="Enter Notify Party"
              error={errors.notify_party}
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Gross Weight"
              name="gross_wt"
              value={formData.gross_wt}
              onChange={handleChange}
              placeholder="Enter Gross Weight"
              error={errors.gross_weight}
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Number of Packages"
              name="number_of_packages"
              value={formData.number_of_packages || formData.packaging}
              onChange={handleChange}
              placeholder="Enter Number of Packages"
              error={errors.number_of_packages}
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Shipment Segment"
              name="shipment_segment"
              value={formData.shipment_segment}
              onChange={handleChange}
              placeholder="Enter Shipment Segment"
              disabled
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Incoterms"
              name="incoterms"
              value={formData.incoterms}
              onChange={handleChange}
              placeholder="Enter Incoterms"
              disabled
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Freight Terms"
              name="freight_terms"
              value={formData.freight_terms}
              onChange={handleChange}
              placeholder="Enter Freight Terms"
              disabled
            />
          </div>
          <div className="col-md-4">
            <InputField
              label="Container Count"
              name="container_count"
              value={formData.container_count}
              onChange={handleChange}
              disabled
            />
          </div>
        </div>

        {/* {Object.keys(errors).length > 0 && (
          <div className="alert alert-danger" role="alert">
            <strong>Please fix the following errors:</strong>
            <ul className="mb-0 mt-2">
              {Object.entries(errors).map(([key, msg]) => (
                <li key={key}>{msg}</li>
              ))}
            </ul>
          </div>
        )} */}

        <div className="position-relative mb-4">
          <div className="ovrflw">
            <table className="table table-bordered tbllbl mb-2 mb-md-3">
              <thead className="table-light">
                <tr>
                  <th>Container Type</th>
                  <th>Weight</th>
                  <th>Length</th>
                  <th>Height</th>
                  <th>Breadth</th>
                  <th>Container Number</th>
                </tr>
              </thead>
              <tbody>
                {console.log("containerTableData", containerTableData)}
                {containerTableData.map((container, index) => (
                  <tr key={index}>
                    <td>{container.container_type ?? "-"}</td>
                    <td>{container.container_weight ?? "-"}</td>
                    <td>{container.container_length ?? "-"}</td>
                    <td>{container.container_height ?? "-"}</td>
                    <td>{container.container_breadth ?? "-"}</td>
                    <td>
                      <InputField
                        placeholder="Enter Container Number"
                        value={container.container_number || ""}

                        onChange={(e) =>
                          handleContainerChange(
                            index,
                            "container_number",
                            e.target.value,

                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {vendors.length === 0
          ? null
          : vendors.map((vendor, vendorIndex) => {

            const totalTaxableAmount = vendor.chargeRows.reduce(
              (sum, charge) => sum + (Number(charge.taxable_amount) || 0),
              0,
            );

            const totalGstAmount = vendor.chargeRows.reduce(
              (sum, charge) =>
                sum +
                (charge.gst_applicable === "No"
                  ? 0
                  : Number(charge.gst_amount) || 0),
              0,
            );

            const totalCgstAmount = vendor.chargeRows.reduce(
              (sum, charge) =>
                sum + (Number(charge.cgst) || 0),
              0,
            );

            const totalSgstAmount = vendor.chargeRows.reduce(
              (sum, charge) =>
                sum + (Number(charge.sgst) || 0),
              0,
            );

            const totalIgstAmount = vendor.chargeRows.reduce(
              (sum, charge) =>
                sum + (Number(charge.igst) || 0),
              0,
            );

            const vendorTotal = totalTaxableAmount + totalGstAmount;

            const currencyRateMap = {};
            [vendor.inputChargeRow, ...vendor.chargeRows].forEach((row) => {
              if (row && row.currency) {
                currencyRateMap[row.currency] = row.exchange_rate;
              }
            });
            const distinctCurrencies = Object.keys(currencyRateMap);

            return (
              <div
                key={vendor.id}
                className="vendor-section mb-5"
                style={{
                  border: "1px solid #dee2e6",
                  borderRadius: 8,
                  padding: 20,
                  overflow: "visible",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0 border-bottom pb-2">
                    As Per Vendor {vendorIndex + 1}
                  </h5>
                  <div className="d-flex align-items-center gap-2">
                    {(vendor.purchase_invoice_file || []).length > 0 && (
                      <Button
                        variant="outline-success"
                        btncls="px-3 "
                        size="small"
                        onClick={() => setFileModalVendorId(vendor.id)}
                        style={{ background: "#198754", color: "#fff" }}
                      >
                        Click to View All Purchase ({(vendor.purchase_invoice_file || []).length})
                      </Button>
                    )}
                    <Button
                      variant="darkblue"
                      btncls="px-3"
                      size="small"
                      onClick={() => {
                        const input = vendorFileRefs.current[vendor.id];
                        if (input) input.click();
                      }}
                      startIcon={<CloudUploadIcon />}
                      children="Upload Purchase Invoice"
                    />
                    <input
                      type="file"
                      multiple
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      ref={(el) => (vendorFileRefs.current[vendor.id] = el)}
                      onChange={(e) => {
                        addVendorFiles(vendor.id, e.target.files);
                        e.target.value = ""; // allow re-selecting same file(s)
                      }}
                      style={{ display: "none" }}
                    />
                    {vendors.length > 0 && (
                      <Button
                        variant="contained"
                        btncls="bg-danger text-white px-3 py-1 vendor-remove-btn"
                        size="small"
                        onClick={() => removeVendor(vendor.id)}
                      >
                        Remove
                      </Button>
                    )}
                  </div>
                </div>

                <div className="row g-3 mb-4">
                  <div className="col-md-4">
                    <label className="form-label">Vendor Name</label>
                    <Select
                      options={vendorOptions}
                      value={
                        vendorOptions.find(
                          (v) => v.value === vendor.vendor_id,
                        ) ||
                        (vendor.vendor_id
                          ? {
                            value: vendor.vendor_id,
                            label: vendor.vendor_name,
                          }
                          : null)
                      }
                      onChange={(selected) =>
                        handleVendorSelect(selected, vendor.id)
                      }
                      placeholder="Select Vendor"
                      isLoading={loadingVendors}
                      isClearable
                    />
                  </div>
                  <div className="col-md-4">
                    <InputField
                      label="Vendor Location"
                      value={vendor.vendor_location}
                      onChange={(e) =>
                        updateVendor(
                          vendor.id,
                          "vendor_location",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Vendor Location"
                    />
                  </div>
                  <div className="col-md-4">
                    <InputField
                      label="GST Number"
                      value={vendor.gst_number}
                      onChange={(e) =>
                        updateVendor(vendor.id, "gst_number", e.target.value)
                      }
                      placeholder="Enter GST Number"
                    />
                  </div>
                  <div className="col-md-4">
                    <InputField
                      label="PAN Number"
                      value={vendor.pan_number}
                      onChange={(e) =>
                        updateVendor(vendor.id, "pan_number", e.target.value)
                      }
                      placeholder="Enter PAN Number"
                    />
                  </div>
                  <div className="col-md-4">
                    <InputField
                      label="Vendor Invoice Number"
                      value={vendor.voucher_invoice_number}
                      onChange={(e) =>
                        updateVendor(
                          vendor.id,
                          "voucher_invoice_number",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Vendor Invoice Number"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Vendor Invoice Date</label>
                    <DatePickerField
                      selected={vendorInvoiceDates[vendorIndex] || null}
                      onChange={(date) => {
                        const newDates = [...vendorInvoiceDates];
                        newDates[vendorIndex] = date;
                        setVendorInvoiceDates(newDates);
                        updateVendor(vendor.id, "voucher_invoice_date", date);
                      }}
                      placeholder="DD/MM/YYYY"
                    />
                  </div>

                  <div className="col-md-4">
                    <InputField
                      label="Vendor Performa Invoice Number"
                      value={vendor.vendor_performa_invoice_number}
                      onChange={(e) =>
                        updateVendor(
                          vendor.id,
                          "vendor_performa_invoice_number",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Performa Invoice Number"
                    />
                  </div>
                  <div className="col-md-4">
                    <InputField
                      label="Vendor Booking Number"
                      value={vendor.vb_number}
                      onChange={(e) =>
                        updateVendor(vendor.id, "vb_number", e.target.value)
                      }
                      placeholder="Enter Vendor Booking Number"
                    />
                  </div>
                  <div className="col-md-4">
                    <InputField
                      label="Vendor Job Number"
                      value={vendor.vendor_job_number}
                      onChange={(e) =>
                        updateVendor(
                          vendor.id,
                          "vendor_job_number",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Vendor Job Number"
                    />
                  </div>
                  <div className="col-md-4">
                    <InputField
                      label="Master Shipper"
                      value={vendor.shipper}
                      onChange={(e) =>
                        updateVendor(vendor.id, "shipper", e.target.value)
                      }
                      placeholder="Enter Master Shipper"
                    />
                  </div>
                  <div className="col-md-4">
                    <InputField
                      label="Master Consignee"
                      value={vendor.consignee}
                      onChange={(e) =>
                        updateVendor(vendor.id, "consignee", e.target.value)
                      }
                      placeholder="Enter Master Consignee"
                    />
                  </div>

                  <div className="col-md-4">
                    <InputField
                      label="Master BL Number"
                      value={vendor.mbl_number}
                      onChange={(e) =>
                        updateVendor(
                          vendor.id,
                          "mbl_number",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Master BL Number"
                    />
                  </div>

                  <div className="col-md-4">
                    <InputField
                      label="Vessel Name"
                      value={vendor.vessel_name}
                      onChange={(e) =>
                        updateVendor(
                          vendor.id,
                          "vessel_name",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Vessel Name"
                    />
                  </div>
                  <div className="col-md-4">
                    <InputField
                      label="Vessel Number"
                      value={vendor.vessel_number}
                      onChange={(e) =>
                        updateVendor(
                          vendor.id,
                          "vessel_number",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Vessel Number"
                    />
                  </div>
                  <div className="col-md-4">
                    <InputField
                      label="Voyage Number"
                      value={vendor.voyage_number}
                      onChange={(e) =>
                        updateVendor(
                          vendor.id,
                          "voyage_number",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Voyage Number"
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Estimated Date</label>

                    <div className="position-relative">
                      <DatePicker
                        selected={
                          vendor.etd_date ? new Date(vendor.etd_date) : null
                        }
                        onChange={(date) => {
                          updateVendor(
                            vendor.id,
                            "etd_date",
                            date ? date.toISOString().split("T")[0] : "",
                          );
                        }}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="DD/MM/YY"
                        className="form-control pe-5"
                        showPopperArrow={false}
                      />

                      <CalendarMonthIcon
                        className="position-absolute"
                        style={{
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#6c757d",
                          pointerEvents: "none",
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Cut Off Date</label>

                    <div className="position-relative">
                      <DatePicker
                        selected={
                          vendor.cut_off_date
                            ? new Date(vendor.cut_off_date)
                            : null
                        }
                        onChange={(date) => {
                          updateVendor(
                            vendor.id,
                            "cut_off_date",
                            date ? date.toISOString().split("T")[0] : "",
                          );
                        }}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="DD/MM/YY"
                        className="form-control pe-5"
                        showPopperArrow={false}
                      />

                      <CalendarMonthIcon
                        className="position-absolute"
                        style={{
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#6c757d",
                          pointerEvents: "none",
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <InputField
                      label="Payment Reference"
                      name="payment_ref"
                      value={vendor.payment_ref}
                      onChange={(e) =>
                        updateVendor(vendor.id, "payment_ref", e.target.value)
                      }
                      placeholder="Enter Payment Reference"
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Payment Date</label>

                    <div className="position-relative">
                      <DatePicker
                        selected={
                          vendor.payment_date
                            ? new Date(vendor.payment_date)
                            : null
                        }
                        onChange={(date) => {
                          updateVendor(
                            vendor.id,
                            "payment_date",
                            date ? date.toISOString().split("T")[0] : "",
                          );
                        }}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="DD/MM/YY"
                        className="form-control"
                        showPopperArrow={false}
                      />

                      <CalendarMonthIcon
                        className="position-absolute"
                        style={{
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#6c757d",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="mb-4 position-relative"
                  style={{ maxHeight: "100%" }}
                >
                  <table className="table table-bordered tbllbl mb-2 mb-md-3">
                    <thead className="table-light">
                      <tr>
                        <th>Charge Code</th>
                        <th>SAC Code</th>
                        <th>Currency</th>
                        <th>Rate</th>
                        <th>Quantity</th>
                        <th>Taxable Amount</th>
                        <th>GST Applicable</th>
                        <th>GST %</th>
                        <th>GST Amount</th>
                        <th>Container(s)</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>


                          <SelectField
                            options={chargeCodeOptions}
                            value={vendor.inputChargeRow.charge_code}
                            onChange={(val) => {
                              updateVendorInputCharge(
                                vendor.id,
                                "charge_code",
                                val,
                              );

                              fetchGSTForChargeCode(val, vendor.id, "input");
                            }}
                            isLoading={loadingChargeCodes}
                            searchable
                          />
                        </td>
                        <td>
                          <InputField
                            type="text"
                            placeholder="SAC Code"
                            value={vendor.inputChargeRow.sac_code || ""}
                            onChange={(e) =>
                              updateVendorInputCharge(
                                vendor.id,
                                "sac_code",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td className="minselect">
                          <Select
                            options={currencyOptions}
                            value={
                              currencyOptions.find(
                                (c) =>
                                  c.value === vendor.inputChargeRow.currency,
                              ) || null
                            }
                            onChange={(selected) =>
                              handleCurrencyChange(vendor.id, "input", selected)
                            }
                            isLoading={loadingCurrencies}
                            placeholder="Select"
                          />
                        </td>
                        <td>
                          <InputField
                            type="text"
                            placeholder="Rate"
                            value={vendor.inputChargeRow.rate || ""}
                            onChange={(e) =>
                              updateVendorInputCharge(
                                vendor.id,
                                "rate",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td>
                          <InputField
                            type="text"
                            placeholder="Quantity"
                            value={vendor.inputChargeRow.quantity || ""}
                            onChange={(e) =>
                              updateVendorInputCharge(
                                vendor.id,
                                "quantity",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td>
                          <InputField
                            type="text"
                            placeholder="Amount"
                            value={vendor.inputChargeRow.taxable_amount || ""}
                            onChange={(e) =>
                              updateVendorInputCharge(
                                vendor.id,
                                "taxable_amount",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td className="minselect">
                          {/* <Select
                              options={[
                                { label: "Yes", value: "Yes" },
                                { label: "No", value: "No" },
                              ]}
                              value={
                                vendor.inputChargeRow.gst_applicable === "No"
                                  ? { label: "No", value: "No" }
                                  : { label: "Yes", value: "Yes" }
                              }
                              onChange={(selected) =>
                                updateVendorInputCharge(
                                  vendor.id,
                                  "gst_applicable",
                                  selected?.value || "Yes",
                                )
                              }
                              placeholder="Select"
                            /> */}

                          <Select
                            options={[
                              { label: "Yes", value: "Yes" },
                              { label: "No", value: "No" },
                            ]}
                            value={
                              vendor.inputChargeRow.gst_applicable === "Yes"
                                ? { label: "Yes", value: "Yes" }
                                : { label: "No", value: "No" }
                            }
                            onChange={(selected) => {
                              const gstApplicable = selected?.value || "No";

                              updateVendorInputCharge(
                                vendor.id,
                                "gst_applicable",
                                gstApplicable,
                              );

                              if (
                                gstApplicable === "Yes" &&
                                vendor.inputChargeRow.charge_code
                              ) {
                                fetchGSTForChargeCode(
                                  vendor.inputChargeRow.charge_code,
                                  vendor.id,
                                  "input",
                                );
                              }
                            }}
                            placeholder="Select"
                          />
                        </td>
                        <td>
                          <InputField
                            type="text"
                            placeholder="GST %"
                            value={vendor.inputChargeRow.gst || ""}
                            onChange={(e) =>
                              updateVendorInputCharge(
                                vendor.id,
                                "gst",
                                e.target.value,
                              )
                            }
                            disabled={
                              vendor.inputChargeRow.gst_applicable === "No"
                            }
                          />
                        </td>
                        <td>
                          <InputField
                            type="text"
                            placeholder="GST Amt"
                            value={
                              vendor.inputChargeRow.gst_applicable === "No"
                                ? "0"
                                : vendor.inputChargeRow.gst_amount || ""
                            }
                            onChange={(e) =>
                              updateVendorInputCharge(
                                vendor.id,
                                "gst_amount",
                                e.target.value,
                              )
                            }
                            disabled={
                              vendor.inputChargeRow.gst_applicable === "No"
                            }
                          />
                        </td>
                        <td className="minselect">
                          <Select
                            isMulti
                            options={containerOptions}
                            value={
                              containerOptions.filter((o) =>
                                (
                                  vendor.inputChargeRow
                                    .applicableContainers || []
                                ).includes(o.value),
                              ) || null
                            }
                            onChange={(selected) =>
                              updateVendorInputCharge(
                                vendor.id,
                                "applicableContainers",
                                (selected || []).map((s) => s.value),
                              )
                            }
                            placeholder="Select Container(s)"
                            isDisabled={containerOptions.length === 0}
                          />
                        </td>
                        <td className="text-center">
                          <AddCircleOutlineIcon
                            style={{
                              cursor: "pointer",
                              color: "green",
                              fontSize: 28,
                            }}
                            onClick={() => addChargeRow(vendor.id)}
                          />
                        </td>
                      </tr>
                      {vendor.chargeRows.map((charge, index) => (
                        <tr key={index}>
                          <td>
                            {/* <SelectField
                                options={chargeCodeOptions}
                                value={charge.charge_code}
                                onChange={(val) => {
                                  handleVendorChargeInputChange(
                                    vendor.id,
                                    index,
                                    "charge_code",
                                    val,
                                  );

                                  fetchGSTForChargeCode(val, vendor.id, index);
                                }}
                                isLoading={loadingChargeCodes}
                                searchable
                              /> */}

                            <SelectField
                              options={chargeCodeOptions}
                              value={charge.charge_code}
                              onChange={(val) => {
                                handleVendorChargeInputChange(
                                  vendor.id,
                                  index,
                                  "charge_code",
                                  val,
                                );

                                if (charge.gst_applicable === "Yes") {
                                  fetchGSTForChargeCode(
                                    val,
                                    vendor.id,
                                    index,
                                  );
                                }
                              }}
                              isLoading={loadingChargeCodes}
                              searchable
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              value={charge.sac_code || ""}
                              onChange={(e) =>
                                handleVendorChargeInputChange(
                                  vendor.id,
                                  index,
                                  "sac_code",
                                  e.target.value,
                                )
                              }
                            />
                          </td>
                          <td className="minselect">
                            <Select
                              options={currencyOptions}
                              value={
                                currencyOptions.find(
                                  (c) => c.value === charge.currency,
                                ) || null
                              }
                              onChange={(selected) =>
                                handleCurrencyChange(vendor.id, index, selected)
                              }
                              isLoading={loadingCurrencies}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              value={charge.rate || ""}
                              onChange={(e) =>
                                handleVendorChargeInputChange(
                                  vendor.id,
                                  index,
                                  "rate",
                                  e.target.value,
                                )
                              }
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              value={charge.quantity || ""}
                              onChange={(e) =>
                                handleVendorChargeInputChange(
                                  vendor.id,
                                  index,
                                  "quantity",
                                  e.target.value,
                                )
                              }
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              value={charge.taxable_amount || ""}
                              onChange={(e) =>
                                handleVendorChargeInputChange(
                                  vendor.id,
                                  index,
                                  "taxable_amount",
                                  e.target.value,
                                )
                              }
                            />
                          </td>
                          <td className="minselect">
                            <Select
                              options={[
                                { label: "Yes", value: "Yes" },
                                { label: "No", value: "No" },
                              ]}
                              value={
                                charge.gst_applicable === "No"
                                  ? { label: "No", value: "No" }
                                  : { label: "Yes", value: "Yes" }
                              }
                              onChange={(selected) =>
                                handleVendorChargeInputChange(
                                  vendor.id,
                                  index,
                                  "gst_applicable",
                                  selected?.value || "Yes",
                                )
                              }
                              placeholder="Select"
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              value={charge.gst || ""}
                              onChange={(e) =>
                                handleVendorChargeInputChange(
                                  vendor.id,
                                  index,
                                  "gst",
                                  e.target.value,
                                )
                              }
                              disabled={charge.gst_applicable === "No"}
                            />
                          </td>
                          <td>
                            <InputField
                              type="text"
                              value={
                                charge.gst_applicable === "No"
                                  ? "0"
                                  : charge.gst_amount || ""
                              }
                              onChange={(e) =>
                                handleVendorChargeInputChange(
                                  vendor.id,
                                  index,
                                  "gst_amount",
                                  e.target.value,
                                )
                              }
                              disabled={charge.gst_applicable === "No"}
                            />
                          </td>
                          <td className="minselect">
                            <Select
                              isMulti
                              options={containerOptions}
                              value={
                                containerOptions.filter((o) =>
                                  (
                                    charge.applicableContainers || []
                                  ).includes(o.value),
                                ) || null
                              }
                              onChange={(selected) =>
                                handleVendorChargeInputChange(
                                  vendor.id,
                                  index,
                                  "applicableContainers",
                                  (selected || []).map((s) => s.value),
                                )
                              }
                              placeholder="Select Container(s)"
                              isDisabled={containerOptions.length === 0}
                            />
                          </td>
                          <td className="text-center">
                            <DeleteOutlineIcon
                              style={{
                                cursor: "pointer",
                                color: "red",
                                fontSize: 28,
                              }}
                              onClick={() =>
                                deleteChargeRow(vendorIndex, index)
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                 
                  <div
  className="d-flex justify-content-between align-items-start mt-3 mb-4 flex-wrap gap-3"
  style={{ width: "100%" }}
>
  {/* LEFT SIDE - Total Taxable & Tax Summary */}
  <div
    style={{
      width: "420px",
      border: "1px solid #dee2e6",
      borderRadius: "6px",
      overflow: "hidden",
      background: "#fff",
      flexShrink: 0,
    }}
  >
    {/* Total Taxable */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "14px 18px",
        borderBottom: "1px solid #dee2e6",
        fontSize: "16px",
      }}
    >
      <strong>Total Taxable</strong>
      <span>{(totalTaxableAmount || 0).toFixed(2)} INR</span>
    </div>

    {/* TDS Deduction */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "14px 18px",
        borderBottom: "1px solid #dee2e6",
        fontSize: "16px",
      }}
    >
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          margin: 0,
          cursor: "pointer",
        }}
      >
        <input
          type="checkbox"
          checked={vendor.tds_deduct || false}
          onChange={(e) => {
            const checked = e.target.checked;

            setVendors((prev) =>
              prev.map((v) =>
                v.id === vendor.id
                  ? { ...v, tds_deduct: checked }
                  : v
              )
            );
          }}
        />

        <strong>
          TDS Deduction ({vendor.tds_percentage || 0}%)
        </strong>
      </label>

      <span>
        {vendor.tds_deduct
          ? (
              ((totalTaxableAmount || 0) *
                (Number(vendor.tds_percentage) || 0)) /
              100
            ).toFixed(2)
          : "0.00"}{" "}
        INR
      </span>
    </div>

    {/* CGST */}
    {totalCgstAmount > 0 && (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "14px 18px",
          borderBottom: "1px solid #dee2e6",
          fontSize: "16px",
        }}
      >
        <strong>CGST</strong>
        <span>{(totalCgstAmount || 0).toFixed(2)} INR</span>
      </div>
    )}

    {/* SGST */}
    {totalSgstAmount > 0 && (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "14px 18px",
          borderBottom: "1px solid #dee2e6",
          fontSize: "16px",
        }}
      >
        <strong>SGST</strong>
        <span>{(totalSgstAmount || 0).toFixed(2)} INR</span>
      </div>
    )}

    {/* IGST */}
    {totalIgstAmount > 0 && (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "14px 18px",
          borderBottom: "1px solid #dee2e6",
          fontSize: "16px",
        }}
      >
        <strong>IGST</strong>
        <span>{(totalIgstAmount || 0).toFixed(2)} INR</span>
      </div>
    )}

    {/* Grand Total */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "16px 18px",
        background: "#e5e5e5",
        fontSize: "16px",
        fontWeight: "700",
      }}
    >
      <strong>Grand Total</strong>

      <strong>
        {(
          (vendorTotal || 0) -
          (vendor.tds_deduct
            ? ((totalTaxableAmount || 0) *
                (Number(vendor.tds_percentage) || 0)) /
              100
            : 0)
        ).toFixed(2)}{" "}
        INR
      </strong>
    </div>
  </div>

  {/* RIGHT SIDE - Exchange Rate */}
  {distinctCurrencies.length > 0 && (
    <div
      style={{
        width: "420px",
        maxWidth: "100%",
        border: "1px solid #dee2e6",
        borderRadius: "6px",
        background: "#fff",
        padding: "14px 18px",
        marginLeft: "auto",
        boxSizing: "border-box",
      }}
    >
      <div
        className="mb-2"
        style={{ fontWeight: 600, fontSize: "15px" }}
      >
        <span style={{ color: "#6c757d", marginRight: 6 }}>
          &#9432;
        </span>
        Exchange Rate
      </div>

      {distinctCurrencies.map((cur) => (
        <div
          key={cur}
          className="d-flex align-items-center gap-2 mb-2"
        >
          <span style={{ minWidth: 60 }}>1 {cur} =</span>

          <InputField
            type="text"
            value={
              currencyRateMap[cur] === undefined ||
              currencyRateMap[cur] === null
                ? ""
                : String(currencyRateMap[cur])
            }
            onChange={(e) =>
              updateCurrencyExchangeRate(
                vendor.id,
                cur,
                e.target.value
              )
            }
            placeholder="Rate"
          />

          <span>INR</span>

          <EditOutlinedIcon
            onClick={() =>
              handleOpenExchangeRateModal(
                vendor.id,
                cur,
                currencyRateMap[cur]
              )
            }
            titleAccess="Edit Exchange Rate"
            style={{
              fontSize: 20,
              color: "#7c8c9d",
              cursor: "pointer",
            }}
          />
        </div>
      ))}
    </div>
  )}
</div>

                  <div className="table-error text-danger mb-2">
                    {errors.vendorTable && vendorIndex === 0 && (
                      <span>{errors.vendorTable}</span>
                    )}
                    {errors[`vendor_${vendorIndex}_charges`] && (
                      <span>{errors[`vendor_${vendorIndex}_charges`]}</span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}

        <div className="d-flex justify-content-start mb-4">


          <Button
            variant="contained"
            btncls="bg-darkblue text-white px-4 py-2 vendor-add-btn"
            onClick={() => {
              setErrors((prev) => ({
                ...prev,
                vendorTable: "",
              }));
              addVendor();
            }}
            startIcon={<AddCircleOutlineIcon />}
            children="Add New Vendor"
          />
        </div>

        {errors.vendorTable && (
          <div className="text-danger mb-4">
            {errors.vendorTable}
          </div>
        )}



        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button
            variant="darkblue"
            btncls="px-4"
            type="button"
            onClick={handleSubmit}
            disabled={loading || loadingSubmit}
            text={loadingSubmit ? "Saving..." : isEditing ? "Update" : "Submit"}
          />
        </div>
      </form>

      {/* Uploaded Files Modal */}
      {fileModalVendorId !== null &&
        (() => {
          const modalVendor = vendors.find((v) => v.id === fileModalVendorId);
          const files = modalVendor?.purchase_invoice_file || [];
          return (
            <div
              className="modal fade show"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              tabIndex="-1"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Uploaded Purchase Invoices</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setFileModalVendorId(null)}
                    />
                  </div>
                  <div className="modal-body">
                    {files.length === 0 ? (
                      <p className="mb-0 text-muted">No files uploaded.</p>
                    ) : (
                      <ul className="list-group">
                        {files.map((file, i) => (
                          <li
                            key={i}
                            className="list-group-item d-flex justify-content-between align-items-center"
                          >
                            <button
                              type="button"
                              className="btn btn-link p-0 text-start text-decoration-none text-truncate"
                              style={{ maxWidth: "80%" }}
                              onClick={() => openFileInNewTab(file)}
                              title={getFileName(file)}
                            >
                              {getFileName(file)}
                            </button>
                            <DeleteOutlineIcon
                              style={{ cursor: "pointer", color: "#dc3545" }}
                              onClick={() =>
                                removeVendorFile(fileModalVendorId, i)
                              }
                            />
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div className="modal-footer">
                    <Button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setFileModalVendorId(null)}
                      text="Close"
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })()}

      {/* Confirmation Modal */}
      {showConfirm && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditing ? "Confirm Update" : "Confirm Purchase Entry"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowConfirm(false)}
                  disabled={loadingSubmit}
                />
              </div>
              <div className="modal-body">
                <p>Are you sure you want to save this purchase entry?</p>
                <p className="mb-0">
                  <strong>Vendors:</strong> {vendors.length} |
                  <strong> Purchase Invoice No:</strong>{" "}
                  {formData.purchase_invoice_number}
                </p>
              </div>
              <div className="modal-footer">
                <Button
                  className="btn btn-secondary"
                  onClick={() => setShowConfirm(false)}
                  disabled={loadingSubmit}
                  text="No"
                />
                <Button
                  className="btn btn-primary"
                  onClick={confirmSubmit}
                  disabled={loadingSubmit}
                  text={loadingSubmit ? "Saving..." : "Yes, Save"}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccess && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-success">Success</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowSuccess(false)}
                />
              </div>
              <div className="modal-body">
                <p>
                  {isEditing
                    ? "Purchase entry updated successfully!"
                    : "Purchase entry created successfully!"}
                </p>
              </div>
              <div className="modal-footer">
                <Button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    setShowSuccess(false);
                    navigate("/billingAndInvoice/invoicing", {
                      state: { refreshPurchases: true },
                    });
                  }}
                  text="Ok"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Backdrop */}
      {(showConfirm || showSuccess || fileModalVendorId !== null) && (
        <div className="modal-backdrop fade show"></div>
      )}

      
{/* Exchange Rate Edit Modal */}
{showExchangeRateModal && (
  <div
    className="modal fade show"
    style={{
      display: "block",
      backgroundColor: "rgba(0,0,0,0.5)",
    }}
    tabIndex="-1"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Edit Exchange Rate</h5>

          <button
            type="button"
            className="btn-close"
            onClick={() => setShowExchangeRateModal(false)}
          />
        </div>

        <div className="modal-body">
          <label className="form-label">Currency</label>

          <input
            type="text"
            className="form-control mb-3"
            value={selectedExchangeRate.currency}
            disabled
          />

          <label className="form-label">Exchange Rate (INR)</label>

          <input
            type="number"
            min="0"
            step="any"
            className="form-control"
            placeholder="Enter exchange rate"
            value={selectedExchangeRate.rate}
            onChange={(e) =>
              setSelectedExchangeRate((prev) => ({
                ...prev,
                rate: e.target.value,
              }))
            }
          />

          <small className="text-muted">
            1 {selectedExchangeRate.currency} ={" "}
            {selectedExchangeRate.rate || "0"} INR
          </small>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowExchangeRateModal(false)}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSaveExchangeRate}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    </>
  );
};

export default PurchaseForm;